import React, {Component} from 'react';
import axios from 'axios';
import $ from 'jquery';
import Header from "./Header";
import SideBar from "./SideBar";
import Chart from 'chart.js/auto';
import Data from "./Data";
import {CircularProgress} from "@material-ui/core";

class Offs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            day: 7,
            allpay: 0,
            alluser: 0,
            allview1: 0,
            allview2: 0,
            allview3: 0
        };
        this.myChart = null;
        this.viewsChart = null;
        this.usersChart = null;
        this.incomeChart = null;
    }

    componentDidMount() {
        $('#progressTop').addClass('invisible');
        $('#no_item').addClass('invisible');

    }

    render() {
        $('#progressTop').addClass('invisible');
        const {allpay,alluser,allview1,allview2,allview3} = this.state;

        let percent2 = (allview2 * 100) / allview1;
        let percent3 = 100 - percent2;
        let p2 = parseFloat(percent2).toFixed(2);
        let p3 = parseFloat(percent3).toFixed(2);

        return (
            <div>
            <Header />
            <div className="container-fluid">
            <div className="row">
            <SideBar li="offspanel" />
            <div className="col-12 col-md-10 bg-light mr-auto p-4" id="main">
                <div
                    className="d-flex justify-content-between align-items-center flex-md-nowrap border-bottom pb-2 my-3">
                    <h1 className="h2">استادان</h1>
                </div>

                <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead>
                        <tr className="table-secondary">
                            <th>کد تخفیف</th>
                            <th>درصد تخفیف</th>
                            <th>مخصوص</th>
                            <th>توضیحات</th>
                            <th>تاریخ انقضا</th>
                            <th>ویرایش / حذف</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>اولین پست شمشال</td>
                            <td>0</td>
                            <td>30</td>
                            <td>
                                <div className="btn-group" role="group" aria-label="Basic example">
                                    <button type="button" className="btn btn-sm btn-primary">ویرایش</button>
                                    <button type="button" className="btn btn-sm btn-danger">حذف</button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            </div>
            </div>
            </div>
        );
    }
}

export default Offs;
